var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCciLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "478.841px",
    height: "149.817px",
    viewBox: "0 0 478.841 149.817",
    enableBackground: "new 0 0 478.841 149.817",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.793,
    y: 3.82,
    width: 471.047,
    height: 139.393
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M149.921,49.158 l-3.195,9.984c0,0-3.754-4.033-12.62-1.797c-8.866,2.236-10.796,12.101-5.245,14.737c5.551,2.635,14.83-2.955,14.83-2.955 l-3.754,9.877c0,0-8.254,5.219-19.17,2.662c-10.916-2.556-11.688-14.465-4.845-22.95C123.244,49.637,134.666,45.297,149.921,49.158 z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M191.63,54.814 c-3.811-8.184-16.748-10.234-28.895-4.579c-12.148,5.656-18.906,16.875-15.096,25.06c3.811,8.185,16.748,10.234,28.895,4.579 C188.682,74.218,195.439,62.999,191.63,54.814z M173.992,72.124c-5.57,2.902-11.791,1.981-13.895-2.056 c-2.104-4.038,0.707-9.664,6.277-12.566s11.791-1.981,13.895,2.056C182.373,63.596,179.562,69.221,173.992,72.124z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M220.024,48.119 c-10.756-0.053-18.664,0-18.664,0L188.74,81.906h11.422l5.668-15.149h0.987l4.047,15.149h11.768l-4.313-16.161 c0,0,7.667-1.172,9.958-5.591C230.567,55.734,230.781,48.172,220.024,48.119z M218.054,57.704 c-0.509,2.906-4.683,7.81-11.299,6.586l3.898-10.419h2.822C215.072,53.87,218.586,54.669,218.054,57.704z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M257.851,48.119 c-10.755-0.053-18.663,0-18.663,0l-12.62,33.787h11.422l5.668-15.149h0.988l4.046,15.149h11.768l-4.313-16.161 c0,0,7.667-1.172,9.958-5.591C268.395,55.734,268.606,48.172,257.851,48.119z M255.881,57.704c-0.51,2.906-4.683,7.81-11.3,6.586 l3.898-10.419h2.822C252.899,53.87,256.413,54.669,255.881,57.704z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M329.452,63.828 l-2.317,5.671h4.394v2.449c-3.131,1.209-7.82,2.114-10.89,0.799c-6.522-2.795-2.995-13.166,5.871-15.402 c8.865-2.236,12.619,1.797,12.619,1.797l3.195-9.984c-15.255-3.861-26.678,0.479-33.999,9.558 c-6.844,8.485-6.07,20.395,4.846,22.95c4.192,0.982,7.989,0.815,11.079,0.239l0.001,0c16.366-1.571,20.163-18.078,20.163-18.078 H329.452z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M273.646,48.095 h11.502c0,0-5.512,13.363-7.708,18.715c-2.197,5.351-2.795,8.746,1.957,9.025c4.753,0.28,7.628-1.598,9.105-5.471 c1.478-3.874,8.147-22.269,8.147-22.269h10.104c0,0-3.501,10.621-6.216,18.022c-2.717,7.402-6.284,16.318-22.312,16.253 c-16.028-0.064-14.483-7.946-11.874-14.762C268.961,60.792,273.646,48.095,273.646,48.095z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M361.269,47.746 L337.306,82.37h10.943l3.021-4.458h9.54l-0.181,4.458h11.022l1.119-34.625H361.269z M355.546,71.603l4.764-7.029h1.038 l-0.284,7.029H355.546z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 411.615,47.746 379.985,47.746 376.896,57.491 387.322,57.491 378.441,82.37 389.464,82.37 398.782,57.491 407.887,57.491  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 434.577,57.17 437.813,48.015 415.714,48.015 403.468,82.368 425.675,82.368 428.499,74.372 417.792,74.372 419.526,69.58  430.192,69.58 432.808,62.176 422.209,62.176 424.023,57.17  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M456.558,48.015 c-10.303-0.157-13.579,0-13.579,0L430.2,82.37h9.345c5.101,0,13.468-0.652,20.259-3.883c6.751-3.211,11.143-10.06,11.159-17.534 C470.979,53.717,466.719,48.168,456.558,48.015z M458.316,67.076c-4.065,9.838-14.325,9.425-14.325,9.425l8.466-22.79 C452.457,53.711,464.013,53.284,458.316,67.076z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M177.633,100.461 l-2.538,5.635c0,0-2.983-2.276-10.025-1.014c-7.043,1.262-8.577,6.829-4.167,8.317c4.41,1.488,11.78-1.668,11.78-1.668 l-2.982,5.575c0,0-6.557,2.946-15.228,1.503c-8.671-1.443-9.285-8.165-3.85-12.954C156.441,100.732,165.514,98.283,177.633,100.461 z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M331.204,100.461 l-2.538,5.635c0,0-2.982-2.276-10.024-1.014c-7.044,1.262-8.577,6.829-4.167,8.317s11.78-1.668,11.78-1.668l-2.982,5.575 c0,0-6.556,2.946-15.228,1.503c-8.672-1.443-9.284-8.165-3.849-12.954C310.012,100.732,319.085,98.283,331.204,100.461z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 203.518,99.665 200.576,106.907 188.995,106.907 191.855,99.665 181.844,99.665 174.017,118.941 184.241,118.941 186.954,112.071  198.479,112.071 195.689,118.941 205.914,118.941 213.528,99.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 237.854,105.068 239.782,100.092 218.107,100.092 210.654,119.208 232.377,119.208 234.188,114.533 222.847,114.533  223.789,112.018 235.164,112.018 236.787,107.826 225.366,107.826 226.4,105.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 236.479,119.208 248.886,100.092 257.778,100.092 260.387,106.268 261.398,106.268 269.919,100.092 279.131,100.092  278.386,119.208 268.429,119.208 268.906,109.995 257.805,118.249 252.506,110.475 246.649,119.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 289.302,100.091 299.604,100.091 291.938,119.208 281.714,119.208  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M349.287,119.207 h9.664l-3.913-19.01h-10.623l-17.573,19.01h9.665l2.539-3.274h9.595L349.287,119.207z M341.834,112.338l3.778-4.872h1.358 l0.961,4.872H341.834z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 371.173,100.197 381.236,100.197 375.406,114.096 387.785,114.096 384.911,119.207 363.266,119.207  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M391.753,112.178 l-2.448,4.899c0,0,6.336,3.674,15.868,2.396c9.531-1.277,14.11-7.508,5.964-10.329c-3.622-1.172-4.553-1.651-4.234-3.302 c0.32-1.651,6.23-1.651,8.76,2.156l2.317-5.938c0,0-3.915-3.088-13.286-1.863c-9.372,1.225-11.582,4.526-11.769,6.922 s4.245,3.814,6.177,4.553c2.37,0.905,3.674,1.384,3.275,2.822c-0.399,1.438-3.674,0.984-5.697,0.293 C394.656,114.096,391.753,112.178,391.753,112.178z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.491,
    y: 90.918,
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    width: 356.324,
    height: 2.502
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M94.574,23.993 H15.488c0.463-0.567,0.938-1.123,1.426-1.668h76.233C93.635,22.87,94.111,23.425,94.574,23.993z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M85.709,15.458 H24.352c0.763-0.581,1.543-1.135,2.336-1.669h56.687C84.167,14.324,84.946,14.878,85.709,15.458z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M69.901,7.366 H40.16c2.391-0.734,4.855-1.293,7.383-1.669h14.975C65.046,6.073,67.511,6.632,69.901,7.366z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M105.89,49.912 H4.172c0.079-0.559,0.166-1.114,0.258-1.668h101.202C105.723,48.798,105.811,49.353,105.89,49.912z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M103.926,41.232 H6.136c0.18-0.559,0.368-1.114,0.563-1.668h96.663C103.559,40.118,103.747,40.673,103.926,41.232z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M100.101,32.235 H9.961c0.305-0.563,0.618-1.119,0.938-1.669h88.262C99.483,31.116,99.796,31.671,100.101,32.235z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M106.391,57.225 c0,0.279-0.004,0.559-0.008,0.834H3.679c-0.004-0.275-0.008-0.555-0.008-0.834s0.004-0.559,0.008-0.834h102.703 C106.386,56.666,106.391,56.945,106.391,57.225z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M105.79,65.204 c-0.083,0.559-0.175,1.118-0.279,1.668H4.551c-0.104-0.551-0.196-1.11-0.279-1.668H105.79z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M103.821,73.538 c-0.184,0.559-0.375,1.114-0.576,1.668H6.816c-0.2-0.554-0.392-1.109-0.576-1.668H103.821z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M100.042,82.322 c-0.305,0.563-0.622,1.118-0.947,1.669H10.966c-0.325-0.551-0.642-1.106-0.946-1.669H100.042z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M94.34,90.736 c-0.467,0.567-0.951,1.122-1.443,1.668H17.164c-0.492-0.546-0.976-1.101-1.442-1.668H94.34z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M84.625,99.787 c-0.809,0.58-1.635,1.139-2.478,1.669H27.914c-0.843-0.53-1.668-1.089-2.478-1.669H84.625z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M69.359,107.246 c-2.594,0.767-5.277,1.326-8.025,1.668H48.728c-2.749-0.342-5.431-0.901-8.025-1.668H69.359z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M92.386,47.745 c-7.987-9.585-12.114-22.763-12.647-26.65c-0.532-3.887-1.177-2.318-1.597,0.533c-3.888,26.385-11.769,24.575-18.958,38.073 C51.996,73.2,59.938,94.447,79.5,93.86c19.542-0.585,23.696-14.963,24.069-23.536C103.941,61.751,100.373,57.332,92.386,47.745z  M73.189,57.544c-1.971,3.728-3.381,5.751-2.769,10.171c0.613,4.42-0.426,6.816-3.674,6.443c-3.248-0.373-5.005-5.183-1.384-10.677 c3.621-5.494,6.23-7.428,6.23-7.428C73.509,54.616,75.159,53.817,73.189,57.544z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.581,
    y: 129.092,
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    width: 1.372,
    height: 11.706
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M225.874,129.093 h1.371v11.722h-1.287l-5.201-6.989c-0.1-0.134-0.234-0.315-0.402-0.543c-0.167-0.229-0.267-0.371-0.3-0.427 c-0.123-0.167-0.307-0.429-0.552-0.786c-0.189-0.268-0.307-0.44-0.351-0.519l-0.134-0.201h-0.017v0.251v0.703v1.054v1.303v6.137 h-1.371v-11.705h1.288l5.201,6.99c0.055,0.078,0.155,0.217,0.3,0.417c0.144,0.201,0.257,0.352,0.334,0.452 c0.079,0.111,0.182,0.256,0.31,0.435c0.128,0.178,0.209,0.29,0.243,0.334c0.167,0.234,0.301,0.417,0.401,0.551l0.151,0.201h0.017 v-0.267v-0.719v-1.037v-1.204V129.093z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M241.768,131.936 l-1.387,0.351l-0.1-0.017c-0.402-0.657-0.954-1.17-1.656-1.538c-0.703-0.368-1.46-0.552-2.274-0.552 c-0.669,0-1.287,0.117-1.856,0.351c-0.568,0.234-1.06,0.557-1.471,0.97c-0.413,0.413-0.736,0.914-0.97,1.505 c-0.234,0.581-0.351,1.221-0.351,1.923c0,0.703,0.117,1.343,0.351,1.923c0.234,0.58,0.563,1.081,0.986,1.505 c0.402,0.402,0.897,0.725,1.488,0.97c0.569,0.234,1.182,0.351,1.84,0.351c0.903,0,1.722-0.217,2.458-0.652 c0.746-0.435,1.31-1.021,1.689-1.756l1.354,0.368c-0.257,0.535-0.563,1.003-0.92,1.405c-0.357,0.401-0.775,0.758-1.254,1.07 s-0.992,0.541-1.538,0.686c-0.547,0.167-1.132,0.25-1.756,0.25c-0.825,0-1.611-0.145-2.358-0.435 c-0.724-0.301-1.364-0.719-1.922-1.254c-0.546-0.535-0.981-1.181-1.304-1.939c-0.313-0.736-0.468-1.555-0.468-2.458 c0-0.87,0.161-1.689,0.484-2.458c0.324-0.759,0.758-1.405,1.305-1.94c0.545-0.536,1.192-0.953,1.939-1.254 c0.736-0.301,1.522-0.452,2.358-0.452c0.59,0,1.142,0.072,1.655,0.217c0.569,0.157,1.064,0.363,1.488,0.619 c0.479,0.278,0.892,0.602,1.237,0.969C241.193,131.055,241.511,131.479,241.768,131.936z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M245,134.962 l-0.052,0.035c0-0.911,0.169-1.77,0.508-2.574c0.339-0.794,0.794-1.472,1.366-2.032c0.572-0.561,1.249-0.999,2.032-1.313 c0.77-0.315,1.593-0.473,2.469-0.473c0.875,0,1.699,0.158,2.469,0.473c0.782,0.315,1.459,0.753,2.032,1.313 c0.583,0.56,1.039,1.232,1.366,2.014c0.338,0.806,0.508,1.664,0.508,2.575c0,0.946-0.164,1.804-0.491,2.574 c-0.327,0.783-0.782,1.454-1.366,2.014c-0.572,0.561-1.25,0.998-2.032,1.314c-0.782,0.303-1.605,0.455-2.469,0.455 s-1.687-0.152-2.469-0.455c-0.759-0.316-1.43-0.753-2.014-1.314c-0.572-0.561-1.027-1.237-1.366-2.031 C245.164,136.766,245,135.907,245,134.962z M246.524,134.944l-0.053,0.018c0,0.735,0.123,1.407,0.368,2.014 c0.245,0.607,0.589,1.133,1.033,1.577c0.42,0.42,0.94,0.759,1.558,1.015c0.596,0.246,1.244,0.368,1.944,0.368 c0.689,0,1.331-0.122,1.927-0.368c0.619-0.256,1.138-0.595,1.558-1.015c0.444-0.444,0.789-0.969,1.033-1.577 c0.246-0.606,0.369-1.284,0.369-2.032c0-0.747-0.123-1.43-0.369-2.049c-0.245-0.607-0.589-1.132-1.033-1.576 c-0.432-0.432-0.946-0.771-1.541-1.016c-0.595-0.245-1.238-0.368-1.927-0.368c-0.7,0-1.348,0.123-1.944,0.368 c-0.595,0.245-1.109,0.583-1.541,1.016c-0.432,0.432-0.771,0.957-1.016,1.576C246.647,133.514,246.524,134.197,246.524,134.944z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M282.573,134.962 l-0.053,0.035c0-0.911,0.169-1.77,0.507-2.574c0.339-0.794,0.795-1.472,1.366-2.032c0.573-0.561,1.249-0.999,2.032-1.313 c0.771-0.315,1.594-0.473,2.469-0.473c0.876,0,1.699,0.158,2.47,0.473c0.782,0.315,1.46,0.753,2.032,1.313 c0.583,0.56,1.038,1.232,1.365,2.014c0.34,0.806,0.508,1.664,0.508,2.575c0,0.946-0.163,1.804-0.49,2.574 c-0.326,0.783-0.783,1.454-1.365,2.014c-0.572,0.561-1.25,0.998-2.031,1.314c-0.783,0.303-1.606,0.455-2.47,0.455 c-0.864,0-1.688-0.152-2.47-0.455c-0.759-0.316-1.432-0.753-2.015-1.314c-0.571-0.561-1.027-1.237-1.366-2.031 C282.736,136.766,282.573,135.907,282.573,134.962z M284.097,134.944l-0.053,0.018c0,0.735,0.122,1.407,0.368,2.014 c0.245,0.607,0.589,1.133,1.032,1.577c0.421,0.42,0.939,0.759,1.559,1.015c0.596,0.246,1.243,0.368,1.945,0.368 c0.688,0,1.33-0.122,1.926-0.368c0.618-0.256,1.139-0.595,1.559-1.015c0.443-0.444,0.788-0.969,1.033-1.577 c0.246-0.606,0.368-1.284,0.368-2.032c0-0.747-0.122-1.43-0.368-2.049c-0.245-0.607-0.59-1.132-1.033-1.576 c-0.432-0.432-0.945-0.771-1.541-1.016c-0.596-0.245-1.238-0.368-1.927-0.368c-0.7,0-1.349,0.123-1.943,0.368 c-0.596,0.245-1.11,0.583-1.542,1.016c-0.433,0.432-0.771,0.957-1.016,1.576C284.219,133.514,284.097,134.197,284.097,134.944z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M272.08,129.092 h3.594v-0.017c1.349,0,2.413,0.33,3.194,0.987c0.769,0.646,1.154,1.561,1.154,2.742c0,1.17-0.386,2.09-1.154,2.759 c-0.769,0.668-1.833,1.003-3.194,1.003h-2.224v4.23h-1.37V129.092z M273.434,135.28h2.191h0.016c0.97,0,1.706-0.217,2.207-0.652 c0.502-0.435,0.753-1.037,0.753-1.806c0-0.792-0.269-1.394-0.803-1.806c-0.546-0.424-1.271-0.636-2.173-0.636h-2.191V135.28z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M303.905,136.517 c0.78-0.241,1.73-1.007,2.157-1.587c0.425-0.58,0.633-1.285,0.633-2.106c0-1.139-0.383-2.041-1.15-2.711 c-0.772-0.667-1.848-1.001-3.229-1.001h-3.563v11.688h1.373v-4.334l-0.017-0.013v-6.074h2.323c0.905,0,1.605,0.217,2.106,0.656 c0.505,0.434,0.755,1.026,0.755,1.772c0,0.714-0.233,1.293-0.705,1.74c-0.479,0.455-1.192,0.684-2.14,0.684l-0.017-0.017h-0.514 v1.239l3.643,4.347h1.538L303.905,136.517z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M266.364,136.517 c0.78-0.241,1.731-1.007,2.157-1.587c0.425-0.58,0.634-1.285,0.634-2.106c0-1.139-0.384-2.041-1.151-2.711 c-0.772-0.667-1.848-1.001-3.229-1.001h-3.562v11.688h1.373v-4.334l-0.017-0.013v-6.074h2.323c0.905,0,1.606,0.217,2.107,0.656 c0.504,0.434,0.754,1.026,0.754,1.772c0,0.714-0.232,1.293-0.705,1.74c-0.479,0.455-1.192,0.684-2.139,0.684l-0.018-0.017h-0.513 v1.239l3.642,4.347h1.538L266.364,136.517z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M319.322,140.798 l-1.305-3.06h-5.869l-1.304,3.06h-1.472l5.083-11.706h1.255l5.082,11.706H319.322z M312.667,136.517h4.833l-1.856-4.348 c-0.09-0.2-0.156-0.356-0.201-0.468c-0.045-0.111-0.101-0.268-0.167-0.468c-0.022-0.066-0.066-0.184-0.134-0.351l-0.05-0.133 h-0.018l-0.05,0.133c-0.067,0.167-0.111,0.285-0.134,0.351c-0.066,0.201-0.123,0.357-0.167,0.468 c-0.045,0.111-0.112,0.268-0.201,0.468L312.667,136.517z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 319.704,129.093 328.901,129.093 328.901,130.38 324.972,130.38 324.972,140.798 323.617,140.798 323.617,130.38 319.704,130.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    points: " 331.13,139.51 337.668,139.51 337.668,140.798 329.759,140.798 329.759,129.092 337.567,129.092 337.567,130.38 331.13,130.38  331.13,133.992 336.297,133.992 336.297,135.213 331.13,135.213  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.7541,
    strokeMiterlimit: 10,
    d: "M339.896,129.092 h4.933l-0.033,0.05c0.824,0,1.61,0.145,2.357,0.436c0.726,0.278,1.365,0.679,1.923,1.203c0.558,0.524,0.992,1.143,1.305,1.856 c0.322,0.735,0.484,1.539,0.484,2.408c0,0.88-0.156,1.666-0.468,2.357c-0.324,0.714-0.747,1.316-1.271,1.807 c-0.523,0.49-1.153,0.881-1.89,1.17c-0.701,0.279-1.472,0.418-2.308,0.418h-5.032V129.092z M341.302,139.51h3.661h-0.034 c0.625,0,1.21-0.1,1.756-0.301c0.547-0.201,1.031-0.496,1.455-0.886c0.424-0.379,0.759-0.848,1.004-1.405 c0.245-0.535,0.367-1.165,0.367-1.889c0-0.725-0.122-1.366-0.367-1.924c-0.245-0.568-0.58-1.053-1.004-1.454 c-0.434-0.413-0.925-0.725-1.472-0.937c-0.578-0.224-1.182-0.335-1.806-0.335h-3.561V139.51z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#037DB7",
    d: "M149.921,49.158l-3.195,9.984c0,0-3.754-4.033-12.62-1.797c-8.866,2.236-10.796,12.101-5.245,14.737 c5.551,2.635,14.83-2.955,14.83-2.955l-3.754,9.877c0,0-8.254,5.219-19.17,2.662c-10.916-2.556-11.688-14.465-4.845-22.95 C123.244,49.637,134.666,45.297,149.921,49.158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#037DB7",
    d: "M191.63,54.814c-3.811-8.184-16.748-10.234-28.895-4.579c-12.148,5.656-18.906,16.875-15.096,25.06 c3.811,8.185,16.748,10.234,28.895,4.579C188.682,74.218,195.439,62.999,191.63,54.814 M173.992,72.124 c-5.57,2.902-11.791,1.981-13.895-2.056c-2.104-4.038,0.707-9.664,6.277-12.566s11.791-1.981,13.895,2.056 C182.373,63.596,179.562,69.221,173.992,72.124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#037DB7",
    d: "M220.024,48.119c-10.756-0.053-18.664,0-18.664,0L188.74,81.906h11.422l5.668-15.149h0.987l4.047,15.149 h11.768l-4.313-16.161c0,0,7.667-1.172,9.958-5.591C230.567,55.734,230.781,48.172,220.024,48.119 M218.054,57.704 c-0.509,2.906-4.683,7.81-11.299,6.586l3.898-10.419h2.822C215.072,53.87,218.586,54.669,218.054,57.704"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#037DB7",
    d: "M257.851,48.119c-10.755-0.053-18.663,0-18.663,0l-12.62,33.787h11.422l5.668-15.149h0.988l4.046,15.149 h11.768l-4.313-16.161c0,0,7.667-1.172,9.958-5.591C268.395,55.734,268.606,48.172,257.851,48.119 M255.881,57.704 c-0.51,2.906-4.683,7.81-11.3,6.586l3.898-10.419h2.822C252.899,53.87,256.413,54.669,255.881,57.704"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#037DB7",
    d: "M329.452,63.828l-2.317,5.671h4.394v2.449c-3.131,1.209-7.82,2.114-10.89,0.799 c-6.522-2.795-2.995-13.166,5.871-15.402c8.865-2.236,12.619,1.797,12.619,1.797l3.195-9.984 c-15.255-3.861-26.678,0.479-33.999,9.558c-6.844,8.485-6.07,20.395,4.846,22.95c4.192,0.982,7.989,0.815,11.079,0.239l0.001,0 c16.366-1.571,20.163-18.078,20.163-18.078H329.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#037DB7",
    d: "M273.646,48.095h11.502c0,0-5.512,13.363-7.708,18.715c-2.197,5.351-2.795,8.746,1.957,9.025 c4.753,0.28,7.628-1.598,9.105-5.471c1.478-3.874,8.147-22.269,8.147-22.269h10.104c0,0-3.501,10.621-6.216,18.022 c-2.717,7.402-6.284,16.318-22.312,16.253c-16.028-0.064-14.483-7.946-11.874-14.762 C268.961,60.792,273.646,48.095,273.646,48.095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#037DB7",
    d: "M361.269,47.746L337.306,82.37h10.943l3.021-4.458h9.54l-0.181,4.458h11.022l1.119-34.625H361.269z  M355.546,71.603l4.764-7.029h1.038l-0.284,7.029H355.546z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#037DB7",
    points: "411.615,47.746 379.985,47.746 376.896,57.491 387.322,57.491 378.441,82.37 389.464,82.37  398.782,57.491 407.887,57.491  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#037DB7",
    points: "434.577,57.17 437.813,48.015 415.714,48.015 403.468,82.368 425.675,82.368 428.499,74.372  417.792,74.372 419.526,69.58 430.192,69.58 432.808,62.176 422.209,62.176 424.023,57.17  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#037DB7",
    d: "M456.558,48.015c-10.303-0.157-13.579,0-13.579,0L430.2,82.37h9.345c5.101,0,13.468-0.652,20.259-3.883 c6.751-3.211,11.143-10.06,11.159-17.534C470.979,53.717,466.719,48.168,456.558,48.015 M458.316,67.076 c-4.065,9.838-14.325,9.425-14.325,9.425l8.466-22.79C452.457,53.711,464.013,53.284,458.316,67.076"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M177.633,100.461l-2.538,5.635c0,0-2.983-2.276-10.025-1.014c-7.043,1.262-8.577,6.829-4.167,8.317 c4.41,1.488,11.78-1.668,11.78-1.668l-2.982,5.575c0,0-6.557,2.946-15.228,1.503c-8.671-1.443-9.285-8.165-3.85-12.954 C156.441,100.732,165.514,98.283,177.633,100.461"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M331.204,100.461l-2.538,5.635c0,0-2.982-2.276-10.024-1.014c-7.044,1.262-8.577,6.829-4.167,8.317 s11.78-1.668,11.78-1.668l-2.982,5.575c0,0-6.556,2.946-15.228,1.503c-8.672-1.443-9.284-8.165-3.849-12.954 C310.012,100.732,319.085,98.283,331.204,100.461"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005596",
    points: "203.518,99.665 200.576,106.907 188.995,106.907 191.855,99.665 181.844,99.665 174.017,118.941  184.241,118.941 186.954,112.071 198.479,112.071 195.689,118.941 205.914,118.941 213.528,99.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005596",
    points: "237.854,105.068 239.782,100.092 218.107,100.092 210.654,119.208 232.377,119.208  234.188,114.533 222.847,114.533 223.789,112.018 235.164,112.018 236.787,107.826 225.366,107.826 226.4,105.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005596",
    points: "236.479,119.208 248.886,100.092 257.778,100.092 260.387,106.268 261.398,106.268  269.919,100.092 279.131,100.092 278.386,119.208 268.429,119.208 268.906,109.995 257.805,118.249 252.506,110.475  246.649,119.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005596",
    points: "289.302,100.091 299.604,100.091 291.938,119.208 281.714,119.208  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M349.287,119.207h9.664l-3.913-19.01h-10.623l-17.573,19.01h9.665l2.539-3.274h9.595L349.287,119.207z  M341.834,112.338l3.778-4.872h1.358l0.961,4.872H341.834z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005596",
    points: "371.173,100.197 381.236,100.197 375.406,114.096 387.785,114.096 384.911,119.207  363.266,119.207  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M391.753,112.178l-2.448,4.899c0,0,6.336,3.674,15.868,2.396c9.531-1.277,14.11-7.508,5.964-10.329 c-3.622-1.172-4.553-1.651-4.234-3.302c0.32-1.651,6.23-1.651,8.76,2.156l2.317-5.938c0,0-3.915-3.088-13.286-1.863 c-9.372,1.225-11.582,4.526-11.769,6.922s4.245,3.814,6.177,4.553c2.37,0.905,3.674,1.384,3.275,2.822 c-0.399,1.438-3.674,0.984-5.697,0.293C394.656,114.096,391.753,112.178,391.753,112.178"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.491,
    y: 90.918,
    clipPath: "url(#SVGID_2_)",
    fill: "#79B7E4",
    width: 356.324,
    height: 2.502
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M94.574,23.993H15.488c0.463-0.567,0.938-1.123,1.426-1.668h76.233 C93.635,22.87,94.111,23.425,94.574,23.993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M85.709,15.458H24.352c0.763-0.581,1.543-1.135,2.336-1.669h56.687 C84.167,14.324,84.946,14.878,85.709,15.458"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M69.901,7.366H40.16c2.391-0.734,4.855-1.293,7.383-1.669h14.975C65.046,6.073,67.511,6.632,69.901,7.366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M105.89,49.912H4.172c0.079-0.559,0.166-1.114,0.258-1.668h101.202 C105.723,48.798,105.811,49.353,105.89,49.912"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M103.926,41.232H6.136c0.18-0.559,0.368-1.114,0.563-1.668h96.663 C103.559,40.118,103.747,40.673,103.926,41.232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M100.101,32.235H9.961c0.305-0.563,0.618-1.119,0.938-1.669h88.262 C99.483,31.116,99.796,31.671,100.101,32.235"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M106.391,57.225c0,0.279-0.004,0.559-0.008,0.834H3.679c-0.004-0.275-0.008-0.555-0.008-0.834 s0.004-0.559,0.008-0.834h102.703C106.386,56.666,106.391,56.945,106.391,57.225"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M105.79,65.204c-0.083,0.559-0.175,1.118-0.279,1.668H4.551c-0.104-0.551-0.196-1.11-0.279-1.668H105.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M103.821,73.538c-0.184,0.559-0.375,1.114-0.576,1.668H6.816c-0.2-0.554-0.392-1.109-0.576-1.668H103.821z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M100.042,82.322c-0.305,0.563-0.622,1.118-0.947,1.669H10.966c-0.325-0.551-0.642-1.106-0.946-1.669 H100.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M94.34,90.736c-0.467,0.567-0.951,1.122-1.443,1.668H17.164c-0.492-0.546-0.976-1.101-1.442-1.668H94.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M84.625,99.787c-0.809,0.58-1.635,1.139-2.478,1.669H27.914c-0.843-0.53-1.668-1.089-2.478-1.669H84.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79B7E4",
    d: "M69.359,107.246c-2.594,0.767-5.277,1.326-8.025,1.668H48.728c-2.749-0.342-5.431-0.901-8.025-1.668 H69.359z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.581,
    y: 129.092,
    fill: "#005596",
    width: 1.372,
    height: 11.706
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M225.874,129.093h1.371v11.722h-1.287l-5.201-6.989c-0.1-0.134-0.234-0.315-0.402-0.543 c-0.167-0.229-0.267-0.371-0.3-0.427c-0.123-0.167-0.307-0.429-0.552-0.786c-0.189-0.268-0.307-0.44-0.351-0.519l-0.134-0.201 h-0.017v0.251v0.703v1.054v1.303v6.137h-1.371v-11.705h1.288l5.201,6.99c0.055,0.078,0.155,0.217,0.3,0.417 c0.144,0.201,0.257,0.352,0.334,0.452c0.079,0.111,0.182,0.256,0.31,0.435c0.128,0.178,0.209,0.29,0.243,0.334 c0.167,0.234,0.301,0.417,0.401,0.551l0.151,0.201h0.017v-0.267v-0.719v-1.037v-1.204V129.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M241.768,131.936l-1.387,0.351l-0.1-0.017c-0.402-0.657-0.954-1.17-1.656-1.538 c-0.703-0.368-1.46-0.552-2.274-0.552c-0.669,0-1.287,0.117-1.856,0.351c-0.568,0.234-1.06,0.557-1.471,0.97 c-0.413,0.413-0.736,0.914-0.97,1.505c-0.234,0.581-0.351,1.221-0.351,1.923c0,0.703,0.117,1.343,0.351,1.923 c0.234,0.58,0.563,1.081,0.986,1.505c0.402,0.402,0.897,0.725,1.488,0.97c0.569,0.234,1.182,0.351,1.84,0.351 c0.903,0,1.722-0.217,2.458-0.652c0.746-0.435,1.31-1.021,1.689-1.756l1.354,0.368c-0.257,0.535-0.563,1.003-0.92,1.405 c-0.357,0.401-0.775,0.758-1.254,1.07s-0.992,0.541-1.538,0.686c-0.547,0.167-1.132,0.25-1.756,0.25 c-0.825,0-1.611-0.145-2.358-0.435c-0.724-0.301-1.364-0.719-1.922-1.254c-0.546-0.535-0.981-1.181-1.304-1.939 c-0.313-0.736-0.468-1.555-0.468-2.458c0-0.87,0.161-1.689,0.484-2.458c0.324-0.759,0.758-1.405,1.305-1.94 c0.545-0.536,1.192-0.953,1.939-1.254c0.736-0.301,1.522-0.452,2.358-0.452c0.59,0,1.142,0.072,1.655,0.217 c0.569,0.157,1.064,0.363,1.488,0.619c0.479,0.278,0.892,0.602,1.237,0.969C241.193,131.055,241.511,131.479,241.768,131.936"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M245,134.962l-0.052,0.035c0-0.911,0.169-1.77,0.508-2.574c0.339-0.794,0.794-1.472,1.366-2.032 c0.572-0.561,1.249-0.999,2.032-1.313c0.77-0.315,1.593-0.473,2.469-0.473c0.875,0,1.699,0.158,2.469,0.473 c0.782,0.315,1.459,0.753,2.032,1.313c0.583,0.56,1.039,1.232,1.366,2.014c0.338,0.806,0.508,1.664,0.508,2.575 c0,0.946-0.164,1.804-0.491,2.574c-0.327,0.783-0.782,1.454-1.366,2.014c-0.572,0.561-1.25,0.998-2.032,1.314 c-0.782,0.303-1.605,0.455-2.469,0.455s-1.687-0.152-2.469-0.455c-0.759-0.316-1.43-0.753-2.014-1.314 c-0.572-0.561-1.027-1.237-1.366-2.031C245.164,136.766,245,135.907,245,134.962 M246.524,134.944l-0.053,0.018 c0,0.735,0.123,1.407,0.368,2.014c0.245,0.607,0.589,1.133,1.033,1.577c0.42,0.42,0.94,0.759,1.558,1.015 c0.596,0.246,1.244,0.368,1.944,0.368c0.689,0,1.331-0.122,1.927-0.368c0.619-0.256,1.138-0.595,1.558-1.015 c0.444-0.444,0.789-0.969,1.033-1.577c0.246-0.606,0.369-1.284,0.369-2.032c0-0.747-0.123-1.43-0.369-2.049 c-0.245-0.607-0.589-1.132-1.033-1.576c-0.432-0.432-0.946-0.771-1.541-1.016c-0.595-0.245-1.238-0.368-1.927-0.368 c-0.7,0-1.348,0.123-1.944,0.368c-0.595,0.245-1.109,0.583-1.541,1.016c-0.432,0.432-0.771,0.957-1.016,1.576 C246.647,133.514,246.524,134.197,246.524,134.944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M282.573,134.962l-0.053,0.035c0-0.911,0.169-1.77,0.507-2.574c0.339-0.794,0.795-1.472,1.366-2.032 c0.573-0.561,1.249-0.999,2.032-1.313c0.771-0.315,1.594-0.473,2.469-0.473c0.876,0,1.699,0.158,2.47,0.473 c0.782,0.315,1.46,0.753,2.032,1.313c0.583,0.56,1.038,1.232,1.365,2.014c0.34,0.806,0.508,1.664,0.508,2.575 c0,0.946-0.163,1.804-0.49,2.574c-0.326,0.783-0.783,1.454-1.365,2.014c-0.572,0.561-1.25,0.998-2.031,1.314 c-0.783,0.303-1.606,0.455-2.47,0.455c-0.864,0-1.688-0.152-2.47-0.455c-0.759-0.316-1.432-0.753-2.015-1.314 c-0.571-0.561-1.027-1.237-1.366-2.031C282.736,136.766,282.573,135.907,282.573,134.962 M284.097,134.944l-0.053,0.018 c0,0.735,0.122,1.407,0.368,2.014c0.245,0.607,0.589,1.133,1.032,1.577c0.421,0.42,0.939,0.759,1.559,1.015 c0.596,0.246,1.243,0.368,1.945,0.368c0.688,0,1.33-0.122,1.926-0.368c0.618-0.256,1.139-0.595,1.559-1.015 c0.443-0.444,0.788-0.969,1.033-1.577c0.246-0.606,0.368-1.284,0.368-2.032c0-0.747-0.122-1.43-0.368-2.049 c-0.245-0.607-0.59-1.132-1.033-1.576c-0.432-0.432-0.945-0.771-1.541-1.016c-0.596-0.245-1.238-0.368-1.927-0.368 c-0.7,0-1.349,0.123-1.943,0.368c-0.596,0.245-1.11,0.583-1.542,1.016c-0.433,0.432-0.771,0.957-1.016,1.576 C284.219,133.514,284.097,134.197,284.097,134.944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M272.08,129.092h3.594v-0.017c1.349,0,2.413,0.33,3.194,0.987c0.769,0.646,1.154,1.561,1.154,2.742 c0,1.17-0.386,2.09-1.154,2.759c-0.769,0.668-1.833,1.003-3.194,1.003h-2.224v4.23h-1.37V129.092z M273.434,135.28h2.191h0.016 c0.97,0,1.706-0.217,2.207-0.652c0.502-0.435,0.753-1.037,0.753-1.806c0-0.792-0.269-1.394-0.803-1.806 c-0.546-0.424-1.271-0.636-2.173-0.636h-2.191V135.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M303.905,136.517c0.78-0.241,1.73-1.007,2.157-1.587c0.425-0.58,0.633-1.285,0.633-2.106 c0-1.139-0.383-2.041-1.15-2.711c-0.772-0.667-1.848-1.001-3.229-1.001h-3.563v11.688h1.373v-4.334l-0.017-0.013v-6.074h2.323 c0.905,0,1.605,0.217,2.106,0.656c0.505,0.434,0.755,1.026,0.755,1.772c0,0.714-0.233,1.293-0.705,1.74 c-0.479,0.455-1.192,0.684-2.14,0.684l-0.017-0.017h-0.514v1.239l3.643,4.347h1.538L303.905,136.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M266.364,136.517c0.78-0.241,1.731-1.007,2.157-1.587c0.425-0.58,0.634-1.285,0.634-2.106 c0-1.139-0.384-2.041-1.151-2.711c-0.772-0.667-1.848-1.001-3.229-1.001h-3.562v11.688h1.373v-4.334l-0.017-0.013v-6.074h2.323 c0.905,0,1.606,0.217,2.107,0.656c0.504,0.434,0.754,1.026,0.754,1.772c0,0.714-0.232,1.293-0.705,1.74 c-0.479,0.455-1.192,0.684-2.139,0.684l-0.018-0.017h-0.513v1.239l3.642,4.347h1.538L266.364,136.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M319.322,140.798l-1.305-3.06h-5.869l-1.304,3.06h-1.472l5.083-11.706h1.255l5.082,11.706H319.322z  M312.667,136.517h4.833l-1.856-4.348c-0.09-0.2-0.156-0.356-0.201-0.468c-0.045-0.111-0.101-0.268-0.167-0.468 c-0.022-0.066-0.066-0.184-0.134-0.351l-0.05-0.133h-0.018l-0.05,0.133c-0.067,0.167-0.111,0.285-0.134,0.351 c-0.066,0.201-0.123,0.357-0.167,0.468c-0.045,0.111-0.112,0.268-0.201,0.468L312.667,136.517z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005596",
    points: "319.704,129.093 328.901,129.093 328.901,130.38 324.972,130.38 324.972,140.798 323.617,140.798  323.617,130.38 319.704,130.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#005596",
    points: "331.13,139.51 337.668,139.51 337.668,140.798 329.759,140.798 329.759,129.092 337.567,129.092  337.567,130.38 331.13,130.38 331.13,133.992 336.297,133.992 336.297,135.213 331.13,135.213  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005596",
    d: "M339.896,129.092h4.933l-0.033,0.05c0.824,0,1.61,0.145,2.357,0.436c0.726,0.278,1.365,0.679,1.923,1.203 c0.558,0.524,0.992,1.143,1.305,1.856c0.322,0.735,0.484,1.539,0.484,2.408c0,0.88-0.156,1.666-0.468,2.357 c-0.324,0.714-0.747,1.316-1.271,1.807c-0.523,0.49-1.153,0.881-1.89,1.17c-0.701,0.279-1.472,0.418-2.308,0.418h-5.032V129.092z  M341.302,139.51h3.661h-0.034c0.625,0,1.21-0.1,1.756-0.301c0.547-0.201,1.031-0.496,1.455-0.886 c0.424-0.379,0.759-0.848,1.004-1.405c0.245-0.535,0.367-1.165,0.367-1.889c0-0.725-0.122-1.366-0.367-1.924 c-0.245-0.568-0.58-1.053-1.004-1.454c-0.434-0.413-0.925-0.725-1.472-0.937c-0.578-0.224-1.182-0.335-1.806-0.335h-3.561V139.51z "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63.278,
    y: 54.628,
    clipPath: "url(#SVGID_2_)",
    fill: "#FDFEFF",
    stroke: "#3A2F90",
    strokeWidth: 0.4065,
    width: 21.897,
    height: 26.139
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#037DB7",
    d: "M92.386,47.745c-7.987-9.585-12.114-22.763-12.647-26.65 c-0.532-3.887-1.177-2.318-1.597,0.533c-3.888,26.385-11.769,24.575-18.958,38.073C51.996,73.2,59.938,94.447,79.5,93.86 c19.542-0.585,23.696-14.963,24.069-23.536C103.941,61.751,100.373,57.332,92.386,47.745 M73.189,57.544 c-1.971,3.728-3.381,5.751-2.769,10.171c0.613,4.42-0.426,6.816-3.674,6.443c-3.248-0.373-5.005-5.183-1.384-10.677 c3.621-5.494,6.23-7.428,6.23-7.428C73.509,54.616,75.159,53.817,73.189,57.544"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCciLogo);
export default __webpack_public_path__ + "static/media/CCI_Logo.44665e3c626d81cc9c9c94f6a8fa15d1.svg";
export { ForwardRef as ReactComponent };